(ns renolit-roofing-service.shared.localization.dictionaries.es.notifications-templates
  (:require
   [renolit-roofing-service.shared.localization.dictionaries.es.notifications-templates.event :as ntf-tpl.event]))

(def registry
  {:event ntf-tpl.event/registry})
